module.exports = __webpack_public_path__ + "static/general-terms-and-conditions-of-charging-services-PKN-ORLEN-flota-2024-7123899234ce00f8930aa6858e1c42e6.pdf";